import React from "react";
import { MsalContext } from "@azure/msal-react";
import { InteractionRequiredAuthError } from "@azure/msal-browser";
import authStore, { types as authTypes } from "./_stores/auth.store";
import AppStore from "./_stores/app.store";
import { DefaultLayout } from "./layouts";
import { toast } from "react-toastify";

import "bootstrap/dist/css/bootstrap.min.css";
import "./shards-dashboard/styles/shards-dashboards.1.1.0.min.css";

class App extends React.Component {
  static contextType = MsalContext;

  constructor(props) {
    super(props);
    this.state = {
      appState: {},
      auth: {},
      sso: {},
    };
    this.showMessage = this.showMessage.bind(this);
  }

  componentWillMount() {
    this.setState({ appState: AppStore.getState() });
    this.appStrUnsub = AppStore.subscribe(() => this.setState({ appState: AppStore.getState() }));
    this.setState({ auth: authStore.getState().auth_reducer, sso: authStore.getState().sso_reducer });
    this.authUnsub = authStore.subscribe(() =>
      this.setState({ auth: authStore.getState().auth_reducer, sso: authStore.getState().sso_reducer })
    );
  }

  componentWillUnmount() {
    this.appStrUnsub();
    this.authUnsub();
  }

  async componentDidMount() {
    console.log("App mount SSO Account => ", this.context.instance.getActiveAccount());
    console.log("App mount authStore state => ", authStore.getState());
    this.SsoSilentLogin();
  }

  async SsoSilentLogin() {
    const { instance } = this.context;
    if (instance.getActiveAccount()) {
      try {
        const ssoResp = await instance.ssoSilent({
          scopes: ["user.read"],
          account: instance.getActiveAccount(),
        });
        console.log("SSO Silent Resp => ", ssoResp);
        authStore.dispatch({ type: authTypes.SET_SSO_STATE, payload: ssoResp });
      } catch (e) {
        console.error("SSO Silent catch => ", e);
        // if (e instanceof InteractionRequiredAuthError) this.showMessage({ msg: e.message, type: "error" });
      }
    }
  }

  showMessage({ msg, type }) {
    toast(msg, {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: true,
      closeOnClick: true,
      type,
    });
  }

  render() {
    const { appState, auth, sso } = this.state;
    return <DefaultLayout appState={appState} auth={auth} sso={sso} />;
  }
}

export default App;
